import React, { useState, useEffect, useRef, useCallback } from 'react';
import { debounce as _debounce } from 'lodash';
import classNames from 'classnames';
import ChatInput from '../chatInput/ChatInputContainer';
import Messages from '../chatOutput/MessagesContainer';
import ChatBotHeader from '../chatBotHeader/ChatBotHeaderContainer';
import { RenderMode } from '../../types';
import OmniBotGreetingMessage from '../greetingMessages/OmniBotGreetingMessage';
const SCROLL_THRESHOLD = 150;
const DEBOUNCE_DELAY = 50;
const ChatBotComponent = ({ updateBotOpenState, mode, renderMode, proxyApp, appContext, actionFunction, messages, commonQuestions, }) => {
    const messageRef = useRef(null);
    const scrollRef = useRef(null);
    const [isScrolling, setIsScrolling] = useState(true);
    const handleScroll = useCallback(() => {
        var _a, _b, _c;
        const elementScrollHeight = ((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
        const currentScrollHeight = (((_b = scrollRef.current) === null || _b === void 0 ? void 0 : _b.scrollTop) || 0) + (((_c = scrollRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) || 0);
        if (elementScrollHeight < currentScrollHeight + SCROLL_THRESHOLD) {
            setIsScrolling(true);
        }
        else {
            setIsScrolling(false);
        }
    }, []);
    const stringifiedMessages = JSON.stringify(messages);
    useEffect(() => {
        if (isScrolling) {
            setTimeout(() => {
                var _a;
                (_a = messageRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
                if (scrollRef.current) {
                    scrollRef.current.scrollTop = scrollRef.current.scrollHeight + 1000;
                }
            }, 100);
        }
    }, [isScrolling, messages, stringifiedMessages]);
    const greetingMessage = (() => {
        switch (renderMode) {
            case RenderMode.FULL_SCREEN:
                return React.createElement(OmniBotGreetingMessage, { messageCount: messages.length });
            default:
                return null;
        }
    })();
    const renderChatBotContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, greetingMessage),
            React.createElement("div", { className: "chatbot-body" },
                React.createElement("div", { className: "response", ref: scrollRef, onScroll: _debounce(handleScroll, DEBOUNCE_DELAY) },
                    React.createElement("div", { className: "message-overflow" },
                        React.createElement(Messages, { messageRef: messageRef, mode: mode, renderMode: renderMode })))),
            React.createElement("div", { className: "input-area" },
                React.createElement(ChatInput, { mode: mode, renderMode: renderMode, proxyApp: proxyApp, appContext: appContext, actionFunction: actionFunction, updateScrolling: setIsScrolling, messages: messages, commonQuestions: commonQuestions }))));
    };
    const chatBotClasses = classNames('chatbot-component', {
        'floating-layout': renderMode === RenderMode.FLOATING,
        'fixed-layout': renderMode === RenderMode.FIXED,
        'full-screen-layout': renderMode === RenderMode.FULL_SCREEN,
        'no-messages': messages.length === 0,
    });
    return (React.createElement("div", { className: chatBotClasses },
        React.createElement(ChatBotHeader, { renderMode: renderMode, updateBotOpenState: updateBotOpenState }),
        React.createElement(React.Fragment, null, renderChatBotContent())));
};
export default ChatBotComponent;
//# sourceMappingURL=ChatBotComponent.js.map